module.exports = __webpack_public_path__ + "static/businessCardsMobile-31e23be89c224cf779fe75a65fd559d4.png";